import { TextFieldProps } from '@mui/material'
import { CommonFieldProps, TextField } from '../../../../../components'
import { useFieldProps } from '../../../../../hooks'
import {
  AddressUpdateEventType,
  AddressUpdateFieldType,
  useAddressUpdateFn
} from '../hooks/useAddressUpdateFn'

export interface PostalInfoProps extends CommonFieldProps {
  postalNumberDisabled: boolean
  postalAreaDisabled: boolean
}

export const PostalInfo = ({
  name,
  executeOnChangeFn,
  postalNumberDisabled,
  postalAreaDisabled
}: PostalInfoProps) => {
  const postalNumberFieldName = `${name}.postinumero`
  const { error: postalNumberError, value: postalNumberValue } =
    useFieldProps<string>(postalNumberFieldName)

  const postalAreaFieldName = `${name}.postitoimipaikka`
  const {
    error: postalAreaError,
    onBlur: postalAreaFormikOnBlur,
    value: postalAreaValue
  } = useFieldProps(postalAreaFieldName)

  const updateAddress = useAddressUpdateFn(name, executeOnChangeFn)

  const postalNumberOnBlur = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    updateAddress({
      event,
      eventType: AddressUpdateEventType.BLUR,
      fieldType: AddressUpdateFieldType.POSTALNUMBER
    })
  }

  const postalNumberOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateAddress({
      event,
      eventType: AddressUpdateEventType.CHANGE,
      fieldType: AddressUpdateFieldType.POSTALNUMBER
    })
  }

  const postalAreaOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateAddress({
      event,
      eventType: AddressUpdateEventType.CHANGE,
      fieldType: AddressUpdateFieldType.POSTALAREA
    })
  }

  const commonTextFieldProps: Pick<TextFieldProps, 'variant'> = {
    variant: 'standard'
  }

  return (
    <>
      <TextField
        {...commonTextFieldProps}
        key={`${name}.postinumero`}
        disabled={postalNumberDisabled}
        error={postalNumberError}
        labelTranslationId="pages.ownInfoPage.baseDetails.addresses.postalCode.text"
        name={postalNumberFieldName}
        onBlur={postalNumberOnBlur}
        onChange={postalNumberOnChange}
        required
        value={postalNumberValue}
      />
      <TextField
        {...commonTextFieldProps}
        key={`${name}.postitoimipaikka`}
        disabled={postalAreaDisabled}
        error={postalAreaError}
        labelTranslationId="pages.ownInfoPage.baseDetails.addresses.city"
        name={postalAreaFieldName}
        onBlur={postalAreaFormikOnBlur}
        onChange={postalAreaOnChange}
        required
        value={postalAreaValue}
      />
    </>
  )
}
